<template>
  <div class="content">
    <wv-header title="会员中心">
<!--      <div class="btn-back" slot="left">-->
<!--        <b @click="$router.go(-1)"><</b>-->
<!--      </div>-->
    </wv-header>
    <div class="cell" v-for="(item, index) in items">
      <wv-group>
        <wv-cell><span slot="bd" class="left">类型</span>
          <span slot="ft">{{item.type}}<span v-if="!item.is_active"> (停用)</span></span>
        </wv-cell>
        <wv-cell><span slot="bd" class="left">通用类型</span><span slot="ft">{{item.assign_type}}</span></wv-cell>
        <wv-cell><span slot="bd" class="left">姓名</span><span slot="ft">{{item.name}}</span></wv-cell>
        <wv-cell><span slot="bd" class="left">卡号</span><span slot="ft">{{item.card_number}}</span></wv-cell>
        <wv-cell><span slot="bd" class="left">折扣</span><span slot="ft">{{item.discount}}</span></wv-cell>
        <wv-cell><span slot="bd" class="left">余额</span><span slot="ft">￥{{item.deposit_amount}}</span></wv-cell>
        <wv-cell v-if="item.expire_date"><span slot="bd" class="left">有效期</span><span slot="ft">{{item.expire_date}}</span></wv-cell>
        <wv-cell v-for="(bonus_item, index) in item.bonus_items" :key="index + 1  ">
          <span slot="bd" class="left">赠卡{{bonus_item.sequence}}</span>
          <span slot="ft">￥{{bonus_item.amount}} (有效期至{{bonus_item.expire_at}})</span>
        </wv-cell>

        <wv-cell is-link :to="{name:'expense', query: { id: item.uuid }}">
          <span slot="bd" class="left">消费记录</span><span slot="ft" style="color: #618e5f">查看</span>
        </wv-cell>
      </wv-group>
    </div>
    <p v-if="loaded && items.length === 0" style="margin-top: 100px; margin-bottom: 50px">
      您的手机号没有会员信息
    </p>
    <wv-button type="default" @click="removeBind()">解除绑定</wv-button>
  </div>
</template>

<script>
  import {getMember, removeBindRequest} from '@/api/login'
  import {removeOpenid} from '@/utils/auth'

  export default {
    created() {
      this.fetchData()
    },
    name: 'member',
    data() {
      return {
        items: [],
        loaded: false,
      }
    },
    methods: {
      fetchData() {
        getMember().then(res => {
          this.items = res;
          this.loaded = true;
        })
      },
      handleTo(item) {
        this.$router.push({name: 'expense', query: {id: item.uuid}})
      },
      removeBind() {
        removeBindRequest().then(res => {
          removeOpenid();
          window.location.href = res.redirect_url
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  b {
    font-size: 22px;
  }

  .content {
    margin-bottom: -50px;
    background-color: #f1f1f1;
  }
  .cell {
    padding: 2% 5%;
  }

  .left {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/cards/member.vue